import { viewbilityAnalyticsAction } from '../../jsCore/organizedByType/actions/analyticsActions'
import { dispatch } from '../../jsCore/application/appStore'
import 'intersection-observer'
import {
  scrollDirectionChanged,
  titleAboveOrBellowViewport,
  userScrollUpTrend,
} from '../../jsCore/store/visibility/visibility.actions'

let viewabilityTracker = null

const config = {
  root: null,
  rootMargin: '0px',
  threshold: 0.5,
}

const isAboveViewport = bounded => bounded.top + bounded.height <= 0

function isAboveTest(entries, observer) {
  entries.forEach(entry =>
    dispatch(titleAboveOrBellowViewport(isAboveViewport(entry.boundingClientRect)))
  )
}

function trackScrollDirection() {
  let previousPosition = window.scrollY
  let isPreviousScrollDirectionUp
  window.addEventListener('scroll', () => {
    const isCurrentScrollDirectionUp = window.scrollY < previousPosition
    if (isPreviousScrollDirectionUp !== isCurrentScrollDirectionUp) {
      // dispatch(scrollDirectionChanged(isCurrentScrollDirectionUp))
      isPreviousScrollDirectionUp = isCurrentScrollDirectionUp
    }
    previousPosition = window.scrollY
  })
}

function trackScrollUpTrend() {
  let anchorScrollUpTrend = window.scrollY
  let previousPosition = window.scrollY
  window.addEventListener('scroll', () => {
    const isCurrentScrollDirectionUp = previousPosition > window.scrollY
    if (isCurrentScrollDirectionUp && anchorScrollUpTrend - previousPosition > 400) {
      dispatch(userScrollUpTrend(true))
      previousPosition = anchorScrollUpTrend = window.scrollY
    } else if (isCurrentScrollDirectionUp) {
      previousPosition = window.scrollY
    } else if (!isCurrentScrollDirectionUp) {
      dispatch(userScrollUpTrend(false))
      anchorScrollUpTrend = previousPosition = window.scrollY
    }
  })
}

function trackIsAboveTitle() {
  const intersection = new IntersectionObserver(isAboveTest)
  if (document.querySelector('.post-article__post-title') !== null) {
    intersection.observe(document.querySelector('.post-article__post-title'))
  }
}

function viabilityTrackerNotInitialized() {
  return viewabilityTracker === null
}

const handleIntersect = (entries, observer) =>
  entries.filter(entry => entry.intersectionRatio > 0.5).forEach(entry => {
    dispatch(
      viewbilityAnalyticsAction(
        entry.target.dataset.viewability_category,
        entry.target.dataset.viewability_action,
        entry.target.dataset.viewability_label
      )
    )
    observer.unobserve(entry.target)
  })

function init() {
  if (viabilityTrackerNotInitialized()) {
    viewabilityTracker = new IntersectionObserver(handleIntersect, config)
    trackIsAboveTitle()
    trackScrollDirection()
    trackScrollUpTrend()
  }
}

function registerSelector(querySelector) {
  if (document.querySelector(querySelector) !== null) {
    viewabilityTracker.observe(document.querySelector(querySelector))
  }
}

export function register(querySelector) {
  if (viabilityTrackerNotInitialized()) {
    init()
  }
  registerSelector(querySelector)
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/viewability/viewbilityTracker.js